import React from "react"
import { Footer, SEO, Layout } from "@components"
import QueryBuilder from "@components/queryBuilder/App"
import QueryFAQ from "../components/queryBuilder/FAQ"
import { Container } from "@components"

const QueryBuilderPage = () => {
  return (
    <>
      <Layout>
        <SEO
          title="DynamoDB Visual Query Builder (Free Tool)"
          description="Don't let the DynamoDB specific query syntax hold you back. Build DynamoDB queries visually and export code for CLI & popular languages SDK formats."
          canonical="https://dynobase.dev/dynamodb-query-builder/"
        />

        <div>
          <QueryBuilder />
          <Container>
            <QueryFAQ />
          </Container>
          <div style={{ marginBottom: "100px" }}></div>
          <Footer noMarginTop />
        </div>
      </Layout>
    </>
  )
}

export default QueryBuilderPage
